import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/solution/real-estate-updated/banner-real.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner real-estate-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Real Estate App Development Company
              </h1>
              <span>Shaping the Future of Real Estate with Powerful Apps</span>
              <p style={{ marginTop: "10px" }}>
                Get high-quality, customized real estate app development
                solutions designed specifically for your business. From design
                to deployment, we ensure your app delivers a seamless and
                professional experience.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your Project!
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-md-auto my-lg-0"
          >
            <div className="banner-mob">
              <StaticImage
                src="../../../images/solution/real-estate-updated/banner-mob.webp"
                alt="tekrevol_web"
                layout="constrained"
                className="d-none d-md-block"
                placeholder="blurred"
                formats={["webp"]}
                width={720}
                height={876}
              />
              <StaticImage
                src="../../../images/solution/real-estate-updated/banner-mob-img.webp"
                alt="tekrevol_web"
                layout="constrained"
                className="d-block d-md-none"
                placeholder="blurred"
                formats={["webp"]}
                width={666}
                height={730}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
